export default __webpack_public_path__ + "static/media/trafficOn.11396b66.png";